/**
 * <StudentResult 
 *		// please describe props here
 *	/>
 *
 * This is ...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 * @redux
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import searchStudentSummary from 'controllers/student/searchStudentSummary';
import StudentName from 'components/StudentName';
import Student from 'mediators/Student';

import './StudentResult.scss';
import locale from './locale';

const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch => {
  return {

  };
};

class StudentResult extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      students: [],
    }
  }

  componentWillMount() {
    this.props.onSearching('student'); // you must tell the parent who you are 
    this.searchStudent();
  }

  searchStudent() {
    
    const schoolId = localStorage.getItem('schoolId');

    searchStudentSummary({
      schoolId,
      studentState: 'all',
      searchKeyword: this.props.searchText,
      itemPerPage: 10, 
      pageNumber: 1,
    })
      .then((res)=>{
        if (res.result === 'success') {
          const searchedNumber = res.total_row;
          
          this.setState({
            students: res.list.map((student)=>{
              return new Student(student);
            }),
            searchedNumber,
          });

          this.props.onSearch(null, {
            searchedNumber,
          });
        }
      })
      .catch((err)=>{
        this.props.onSearch(err, {})
      });
  }
  
  render() {
    const {
      students = [],
      searchedNumber = 0,
    } = this.state;
  
    if (!searchedNumber) {
      return <span/>
    }

    return (
      <div className='SearchResult--category StudentResult'>
        <div className='SearchResult--category--title'>{__('Students', locale)} ({searchedNumber})</div>
        <ul className='StudentResult--list'>
          {students.map((student, key)=>{
            return (
              <li key={key} className='SearchResult--category--item StudentResult--list--item'>
                <StudentName name={student.name} id={student.id} /> 
              </li>
            )
          })}
        </ul>
        { searchedNumber > students.length && <p><a>{__('View more', locale)}...</a></p> }
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentResult);



// WEBPACK FOOTER //
// ./src/containers/Main/SearchResult/StudentResult/index.js